module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-sad.bcd2f2d1.png";